function StartScreen({numQuestions, dispatch}) {
    return (
        <div className="start">
            <h2>Welcome to the Frack to School Quiz!</h2>
            <h3>{numQuestions} questions to test your knowledge about the impact of hydraulic fracturing (fracking) operations on schools in Colorado.</h3>
            <button className="btn btn-right" onClick={() => dispatch({type: 'start'})}>Start Quiz</button>
        </div>
    )
}

export default StartScreen
